<div class="flex-fill d-flex flex-column">
    <dx-form class="d-flex ml-4 my-2" *ngIf="filter" [formData]="filter">
        <dxi-item [label]="{ text: 'Table' }" *ngIf="filter">
            <div *dxTemplate>
                <dx-select-box [(value)]="filter.table" [items]="tables" [searchEnabled]="true" (onValueChanged)="selectionChanged($event)"></dx-select-box>
            </div>
        </dxi-item>
    </dx-form>
    <div class="m-1 grid-fill" *ngIf="entities">
        <dx-data-grid
            #dataGrid
            keyExpr="id"
            [dataSource]="entities"
            (onToolbarPreparing)="onToolbarPreparing($event)"
            (onCellDblClick)="rowDoubleClick($event)"
            (onCellPrepared)="onCellPrepared($event)"
            >
            <dxi-column dataField="name" width="350"></dxi-column>
            <dxi-column *ngIf="filter.table === 'Time Categories'" dataField="isVisibleToEmployee" width="200"></dxi-column>
            <dxi-column *ngIf="filter.table === 'Time Categories'" dataField="notesRequired" width="200"></dxi-column>
            <dxi-column *ngIf="filter.table === 'Job Types'" dataField="color" width="200"></dxi-column>
            <dxi-column dataField="displayOrder" width="300"></dxi-column>
            <dxi-column></dxi-column>

            <div *dxTemplate="let data of 'toolbarButtons'">
                <button
                    type="button"
                    (click)="openSelection(dataGrid.instance.getSelectedRowsData()[0])"
                    [disabled]="dataGrid.instance.getSelectedRowsData().length === 0"
                    class="btn btn-success ml-2"
                >
                    Edit
                </button>
                <button type="button" (click)="openSelection()" class="btn btn-secondary ml-2">New</button>
                <button
                    type="button"
                    [disabled]="dataGrid.instance.getSelectedRowsData().length === 0"
                    (click)="delete(dataGrid.instance.getSelectedRowsData()[0])"
                    class="ml-3 btn btn-danger"
                >
                    Delete
                </button>
            </div>
            <dxo-row-dragging [allowReordering]="true" [onReorder]="onReorder" [showDragIcons]="false"></dxo-row-dragging>
        </dx-data-grid>
    </div>
</div>
